import React, { useCallback, useState, lazy, Suspense } from 'react';
import {
  Button,
  TextInput,
  NumberInput,
  Select,
  SelectItem,
  Checkbox,
  DataTable,
  TableRow,
  TableHead,
  TableHeader,
  TableContainer,
  TableCell,
  Table,
  TableBody,
  TableToolbar,
  TableToolbarContent,
} from 'carbon-components-react';

import Collapsible from 'react-collapsible';
import { Tabs, Tab, TabPanel, TabList } from 'react-web-tabs';
import { Tooltip as ReactTooltip } from "react-tooltip";


import { safeLoad, getDivHeight, jsonToYaml, updateStyle, updateStyle2, validateField, toggleDescription } from '../../helpers';

const AdvancedconfigurationDeleteModal = lazy(() => import('./advancedconfigurationDeleteModal'));
const AdvancedconfigurationAdd = lazy(() => import('./advancedconfigurationAdd'));
const AdvancedconfigurationEdit = lazy(() => import('./advancedconfigurationEdit'));
const AdvancedconfigurationvalueDeleteModal = lazy(() => import('./advancedconfigurationvalueDeleteModal'));
const AdvancedconfigurationvalueAdd = lazy(() => import('./advancedconfigurationvalueAdd'));
const AdvancedconfigurationvalueEdit = lazy(() => import('./advancedconfigurationvalueEdit'));


const handleChange = () =>{
    var yamlText = window.iagyaml;

    var json = {};

    if(yamlText !== null && yamlText !== undefined) {
        json = safeLoad(yamlText);
        if(json === undefined || json === null) {
          json = {};
        }
    }

    var newElem = {};
    newElem["configuration"] = advanced_configurationrowData.advanced_configuration;
    json["advanced"] = newElem;

    var yamlop = jsonToYaml(json);
    window.iagyaml = yamlop;
};

  const closeAdd = (idPrefix) => {

      if(idPrefix === undefined) idPrefix = "";

      updateStyle("advanced_div" + idPrefix, "display", "block");
      document.getElementById("advanced_tab" + idPrefix).style.display = "flex";

  };

const advanced_configurationheaderData = [
    {
    header: 'Entry',
    key: 'entry',
  },
{
    header: 'Operation',
    key: 'operation',
  },
{
    header: 'Stanza',
    key: 'stanza',
  },

];

const advanced_configurationrowData = {advanced_configuration: []};

const advanced_configurationhandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("advanced_configuration_entry_id" + idPrefix).value = "";
    document.getElementById("advanced_configuration_operation_id" + idPrefix).value = "";
    document.getElementById("advanced_configuration_stanza_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("advanced_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addadvanced_configurationPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("advanced_tab" + idPrefix).style.display = "none";

  };
const advanced_configuration_valueheaderData = [
    {
    header: 'Value',
    key: 'value',
  },

];

const advanced_configuration_valuerowData = {advanced_configuration_value: []};

const advanced_configuration_valuehandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("advanced_configuration_value_value_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("advanced_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addadvancedconfiguration_valuePage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("advanced_tab" + idPrefix).style.display = "none";

  };


const AdvancedPage = () => {

  const idPrefix = "";

  if(window.iagpage != "AdvancedPage") {
    delete(window.editing);
    delete(window.rowId);
    window.iagpage = "AdvancedPage";
  }

    const [advanced_configuration, setadvanced_configuration] = React.useState([]);
    const [fetchedadvanced_configuration, setFetchedadvanced_configuration] = React.useState(false);

    React.useEffect(() => {
      advanced_configurationloadGrid();
    }, [fetchedadvanced_configuration]);

    const advanced_configurationloadGrid = React.useCallback(async (advanced_configuration_entry, advanced_configuration_operation, advanced_configuration_stanza, advanced_configuration_value,add) => {
      try {
        var attrs = [];
        if(advanced_configuration_entry || advanced_configuration_stanza || advanced_configuration_operation) {
          if(add) {
            for(var i = 0; i < advanced_configurationrowData.advanced_configuration.length; i++) {
              var tempId = ((advanced_configurationrowData.advanced_configuration[i].entry)?advanced_configurationrowData.advanced_configuration[i].entry:"") + ((advanced_configurationrowData.advanced_configuration[i].stanza)?advanced_configurationrowData.advanced_configuration[i].stanza:"") + ((advanced_configurationrowData.advanced_configuration[i].operation)?advanced_configurationrowData.advanced_configuration[i].operation:"") + "";
              if((window.advanced_configurationediting != true && window.advanced_configurationediting != "true") || tempId != window.advanced_configurationrowId) {
                attrs.push(advanced_configurationrowData.advanced_configuration[i]);
              }
            }
            var newId = ((advanced_configuration_entry)?advanced_configuration_entry:"") + ((advanced_configuration_stanza)?advanced_configuration_stanza:"") + ((advanced_configuration_operation)?advanced_configuration_operation:"") + "";
            attrs.push({
              id: newId,
              entry: advanced_configuration_entry,
operation: advanced_configuration_operation,
stanza: advanced_configuration_stanza,
value: advanced_configuration_value,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < advanced_configurationrowData.advanced_configuration.length; i++) {
              if(advanced_configurationrowData.advanced_configuration[i].entry !== advanced_configuration_entry  && advanced_configurationrowData.advanced_configuration[i].stanza !== advanced_configuration_stanza  && advanced_configurationrowData.advanced_configuration[i].operation !== advanced_configuration_operation ) {
                attrs.push(advanced_configurationrowData.advanced_configuration[i]);
              }
            }
          }
        } else {
          attrs = advanced_configurationrowData.advanced_configuration;
        }
        advanced_configurationrowData.advanced_configuration = attrs;
        const data = {advanced_configuration: attrs};
        setadvanced_configuration(data.advanced_configuration);

        if(advanced_configuration_entry !== undefined && advanced_configuration_entry !== null  && advanced_configuration_stanza !== undefined && advanced_configuration_stanza !== null  && advanced_configuration_operation !== undefined && advanced_configuration_operation !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [advanced_configuration_value, setadvanced_configuration_value] = React.useState([]);
    const [fetchedadvanced_configuration_value, setFetchedadvanced_configuration_value] = React.useState(false);

    React.useEffect(() => {
      advanced_configuration_valueloadGrid();
    }, [fetchedadvanced_configuration_value]);

    const advanced_configuration_valueloadGrid = React.useCallback(async (advanced_configuration_value_value, add) => {
      try {
        var attrs = [];
        if(advanced_configuration_value_value) {
          if(add) {
            for(var i = 0; i < advanced_configuration_valuerowData.advanced_configuration_value.length; i++) {
              var tempId = ((advanced_configuration_valuerowData.advanced_configuration_value[i].value)?advanced_configuration_valuerowData.advanced_configuration_value[i].value:"") + "";
              if((window.advanced_configuration_valueediting != true && window.advanced_configuration_valueediting != "true") || tempId != window.advanced_configuration_valuerowId) {
                attrs.push(advanced_configuration_valuerowData.advanced_configuration_value[i]);
              }
            }
            var newId = ((advanced_configuration_value_value)?advanced_configuration_value_value:"") + "";
            attrs.push({
              id: newId,
              value: advanced_configuration_value_value,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < advanced_configuration_valuerowData.advanced_configuration_value.length; i++) {
              if(advanced_configuration_valuerowData.advanced_configuration_value[i].value !== advanced_configuration_value_value ) {
                attrs.push(advanced_configuration_valuerowData.advanced_configuration_value[i]);
              }
            }
          }
        } else {
          attrs = advanced_configuration_valuerowData.advanced_configuration_value;
        }
        advanced_configuration_valuerowData.advanced_configuration_value = attrs;
        const data = {advanced_configuration_value: attrs};
        setadvanced_configuration_value(data.advanced_configuration_value);

        if(advanced_configuration_value_value !== undefined && advanced_configuration_value_value !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });



    const [advanced_configuration_entry, setadvanced_configuration_entry] = useState(''),
    updateadvanced_configuration_entry = useCallback((evt) => {
      setadvanced_configuration_entry(evt.target.value);
      var stanzaWdgt = document.getElementById("advanced_configuration_stanza_id" + idPrefix);
      var stanzaVal = (stanzaWdgt)?stanzaWdgt.value:"";
      var operationWdgt = document.getElementById("advanced_configuration_operation_id" + idPrefix);
      var operationVal = (operationWdgt)?operationWdgt.value:"";
      var tempId = evt.target.value + stanzaVal + operationVal;
      validateField(advanced_configurationrowData.advanced_configuration, setadvanced_configuration_stanza_valid, setadvanced_configuration_stanza_invalid_text, "Advanced Configuration", "unique values", tempId);
      validateField(advanced_configurationrowData.advanced_configuration, setadvanced_configuration_operation_valid, setadvanced_configuration_operation_invalid_text, "Advanced Configuration", "unique values", tempId);
      validateField(advanced_configurationrowData.advanced_configuration, setadvanced_configuration_entry_valid, setadvanced_configuration_entry_invalid_text, "Advanced Configuration", "unique values", tempId);
    }, []);

    const [advanced_configuration_entry_valid, setadvanced_configuration_entry_valid] = useState(true);
    const [advanced_configuration_entry_invalid_text, setadvanced_configuration_entry_invalid_text] = useState("");


    const [advanced_configuration_operation, setadvanced_configuration_operation] = useState(''),
    updateadvanced_configuration_operation = useCallback((evt) => {
      setadvanced_configuration_operation(evt.target.value);
      var entryWdgt = document.getElementById("advanced_configuration_entry_id" + idPrefix);
      var entryVal = (entryWdgt)?entryWdgt.value:"";
      var stanzaWdgt = document.getElementById("advanced_configuration_stanza_id" + idPrefix);
      var stanzaVal = (stanzaWdgt)?stanzaWdgt.value:"";
      var tempId = entryVal + stanzaVal + evt.target.value;
      validateField(advanced_configurationrowData.advanced_configuration, setadvanced_configuration_entry_valid, setadvanced_configuration_entry_invalid_text, "Advanced Configuration", "unique values", tempId);
      validateField(advanced_configurationrowData.advanced_configuration, setadvanced_configuration_stanza_valid, setadvanced_configuration_stanza_invalid_text, "Advanced Configuration", "unique values", tempId);
      validateField(advanced_configurationrowData.advanced_configuration, setadvanced_configuration_operation_valid, setadvanced_configuration_operation_invalid_text, "Advanced Configuration", "unique values", tempId);
    }, []);

    const [advanced_configuration_operation_valid, setadvanced_configuration_operation_valid] = useState(true);
    const [advanced_configuration_operation_invalid_text, setadvanced_configuration_operation_invalid_text] = useState("");


    const [advanced_configuration_stanza, setadvanced_configuration_stanza] = useState(''),
    updateadvanced_configuration_stanza = useCallback((evt) => {
      setadvanced_configuration_stanza(evt.target.value);
      var entryWdgt = document.getElementById("advanced_configuration_entry_id" + idPrefix);
      var entryVal = (entryWdgt)?entryWdgt.value:"";
      var operationWdgt = document.getElementById("advanced_configuration_operation_id" + idPrefix);
      var operationVal = (operationWdgt)?operationWdgt.value:"";
      var tempId = entryVal + evt.target.value + operationVal;
      validateField(advanced_configurationrowData.advanced_configuration, setadvanced_configuration_entry_valid, setadvanced_configuration_entry_invalid_text, "Advanced Configuration", "unique values", tempId);
      validateField(advanced_configurationrowData.advanced_configuration, setadvanced_configuration_operation_valid, setadvanced_configuration_operation_invalid_text, "Advanced Configuration", "unique values", tempId);
      validateField(advanced_configurationrowData.advanced_configuration, setadvanced_configuration_stanza_valid, setadvanced_configuration_stanza_invalid_text, "Advanced Configuration", "unique values", tempId);
    }, []);

    const [advanced_configuration_stanza_valid, setadvanced_configuration_stanza_valid] = useState(true);
    const [advanced_configuration_stanza_invalid_text, setadvanced_configuration_stanza_invalid_text] = useState("");



  if(window.iagpage != "AdvancedPage") {
    delete(window.editing);
    delete(window.rowId);
    window.iagpage = "AdvancedPage";
  }

    const [fetcheddata, setFetcheddata] = React.useState(false);
    React.useEffect(() => {
      dataLoad();
    }, [fetcheddata]);
    const dataLoad = () => {
      var yamlText = window.iagyaml;
      var json = {};
      if(yamlText !== null && yamlText !== undefined) {
        json = safeLoad(yamlText);
        if(json === undefined || json === null) {
          json = {};
        }
      }

      for(var i = 0; i < advanced_configurationrowData.advanced_configuration.length; i++) {
        if(advanced_configurationrowData.advanced_configuration[i].id === window.advanced_configurationrowId) {
        setadvanced_configuration_entry((advanced_configurationrowData.advanced_configuration[i] !== undefined && advanced_configurationrowData.advanced_configuration[i].entry !== undefined )?advanced_configurationrowData.advanced_configuration[i].entry:"");
        setadvanced_configuration_operation((advanced_configurationrowData.advanced_configuration[i] !== undefined && advanced_configurationrowData.advanced_configuration[i].operation !== undefined )?advanced_configurationrowData.advanced_configuration[i].operation:"");
        setadvanced_configuration_stanza((advanced_configurationrowData.advanced_configuration[i] !== undefined && advanced_configurationrowData.advanced_configuration[i].stanza !== undefined )?advanced_configurationrowData.advanced_configuration[i].stanza:"");
        }
      }


      return true;
    };
    const [fetchedadvanced, setFetchedadvanced] = React.useState(false);
    React.useEffect(() => {
      getadvanced();
    }, [fetchedadvanced]);

    const getadvanced = () => {

      var yamlText = window.iagyaml;
      var json = {};
      if(yamlText !== null && yamlText !== undefined) {
        json = safeLoad(yamlText);
        if(json === undefined || json === null) {
          json = {};
        }
      }

            advanced_configurationrowData.advanced_configuration = [];

        if(json !== undefined && json.advanced !== undefined ) {
          if(json !== undefined && json.advanced !== undefined && json.advanced.configuration !== undefined ) {
            var newconfigurations = [];
            for(var i = 0; i < json.advanced.configuration.length; i++) {
              var newItem = {};
              var tempId = ((json.advanced.configuration[i].entry)?json.advanced.configuration[i].entry:"") + ((json.advanced.configuration[i].stanza)?json.advanced.configuration[i].stanza:"") + ((json.advanced.configuration[i].operation)?json.advanced.configuration[i].operation:"");
              newItem["id"] = tempId;
              newItem["entry"] = json.advanced.configuration[i].entry;
              newItem["operation"] = json.advanced.configuration[i].operation;
              newItem["stanza"] = json.advanced.configuration[i].stanza;
              if(json !== undefined && json.advanced !== undefined && json.advanced.configuration[i] !== undefined && json.advanced.configuration[i].value !== undefined ) {
                var newvalues = [];
                for(var i2 = 0; i2 < json.advanced.configuration[i].value.length; i2++) {
                    var newvalue = {};
                    newvalue["id"] = json.advanced.configuration[i].value[i2];
                    newvalue["value"] = json.advanced.configuration[i].value[i2];
                    newvalues.push(newvalue);
                }
                newItem["value"] = newvalues;
                }
              advanced_configurationrowData.advanced_configuration.push(newItem);
            }
            }
        }
    };



    const setDataMain = (functionName, data) => {
      if(functionName && data) {
        eval(functionName)(data);
      }
    };

    return (
        <div className="bx--grid--no-gutter bx--grid--full-width landing-page">
          <div className="bx--row landing-page__banner" style={{paddingBottom:"3rem"}}>
            <div className="bx--col-lg-13 bx--offset-lg-1">
              <h1 className="landing-page__heading">
                Advanced
              </h1>
            </div>
            <div className="bx--col-lg-13 bx--offset-lg-1">
              <h4 className="landing-page__desc" style={{marginTop:"30px"}}>The `advanced` node defines advanced daemon tuning parameters.
</h4>
            </div>            <div id="warning_div" className="bx--col-lg-13" style={{display:'none', color:'red', position:'absolute', bottom:'0', marginBottom: '10px'}}></div>
          </div>
          <div className="bx--row landing-page__r2">
            <div className="bx--col bx--no-gutter">
              <div id="advancedPage" className="bx--col">
                <br/><br/><br/>
            <Tabs id={"advanced_tab" + idPrefix} defaultTab={"configuration_tab" + idPrefix} vertical className="vertical-tabs" style={{overflow:'auto'}}>
              <TabList>
                <Tab tabFor={"configuration_tab" + idPrefix}>Configuration</Tab>
              </TabList>
              <TabPanel style={{width:'100%', overflow:'auto'}} tabId={"configuration_tab" + idPrefix}>
                <div className= {"iag_form_elem iag_tab_heading advanced_div" + idPrefix}>
                  <span className="iag_breadcrumb">Advanced : </span><br/>                  <h2>Configuration Settings</h2><hr/>
                </div>
                <div className={"iag--simple-div advanced_div" + idPrefix}>
                <div className= {"iag_form_elem advanced_div" + idPrefix}>
  <h3 tabIndex="0"  data-tooltip-id={"advanced_configuration_tooltip_id" + idPrefix} >Configuration</h3><hr/>
</div>
          <ReactTooltip id={"advanced_configuration_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>This entry defines customize legacy reverse proxy daemon configuration entries. This configuration is applied last and can be used to overload parameters specified in other sections of the configuration YAML.<br/>This entry is an array and can be used to specify multiple tuning parameters.<br/></div></ReactTooltip>

                <div id={"advanced_configurationTableDiv" + idPrefix} style={{marginLeft:"10px",marginBottom:"10px"}}>
                  <div className={"iag_form_elem advanced_div" + idPrefix}>
                    <DataTable id={"advanced_configurationTable" + idPrefix} isSortable
                        headers={advanced_configurationheaderData}
                        rows={advanced_configurationrowData.advanced_configuration}
                        render={({
                          rows,
                          headers,
                          getHeaderProps,
                          getRowProps,
                          getTableProps,
                          getToolbarProps,
                          onInputChange,
                          getTableContainerProps
                    }) => (
                      <TableContainer>
                        <TableToolbar aria-label="data table toolbar">
                          <TableToolbarContent>
                            <Button onClick={() => {advanced_configurationhandleAdd(idPrefix, [setadvanced_configuration_entry(''),    setadvanced_configuration_entry_valid(true),    setadvanced_configuration_operation(''),    setadvanced_configuration_operation_valid(true),    setadvanced_configuration_stanza(''),    setadvanced_configuration_stanza_valid(true),]);}}>Add</Button>
                          </TableToolbarContent>
                        </TableToolbar>
                        <Table size='normal' {...getTableProps()}>
                          <TableHead>
                            <TableRow>
                              {headers.map(header => (
                                <TableHeader {...getHeaderProps({ header })}>
                                  {header.header}
                                </TableHeader>
                              ))}
                              <TableHeader>
                                  Actions
                              </TableHeader>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {rows.map(row => (
                              <TableRow key={row.id}>
                                {row.cells.map(cell => (
                                  <TableCell key={cell.id}>{cell.value}</TableCell>
                                ))}
                                <TableCell>
                                  <Suspense fallback={<div></div>}>
                                    <AdvancedconfigurationDeleteModal row={row} loadGrid={advanced_configurationloadGrid} />
                                  </Suspense>
                                  <Suspense fallback={<div></div>}>
                                    <AdvancedconfigurationEdit  data={advanced_configurationrowData.advanced_configuration} setData={setDataMain} row={row} loadGrid={advanced_configurationloadGrid} dataLoad={dataLoad} editing={true} name={"advanced_configuration"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updateadvanced_configuration_entry={updateadvanced_configuration_entry} advanced_configuration_entry={advanced_configuration_entry}
            advanced_configuration_entry_valid={advanced_configuration_entry_valid}
            advanced_configuration_entry_invalid_text={advanced_configuration_entry_invalid_text}
            updateadvanced_configuration_operation={updateadvanced_configuration_operation} advanced_configuration_operation={advanced_configuration_operation}
            advanced_configuration_operation_valid={advanced_configuration_operation_valid}
            advanced_configuration_operation_invalid_text={advanced_configuration_operation_invalid_text}
            updateadvanced_configuration_stanza={updateadvanced_configuration_stanza} advanced_configuration_stanza={advanced_configuration_stanza}
            advanced_configuration_stanza_valid={advanced_configuration_stanza_valid}
            advanced_configuration_stanza_invalid_text={advanced_configuration_stanza_invalid_text}
                                    />
                                  </Suspense>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>)}
                    />
                  </div>
                </div>

                </div>
              </TabPanel>
            </Tabs>
                  <Suspense fallback={<div></div>}>
                    <AdvancedconfigurationAdd loadGrid={advanced_configurationloadGrid} doClose={() => {closeAdd(idPrefix);}} idPrefix={idPrefix} 
            updateadvanced_configuration_entry={updateadvanced_configuration_entry} advanced_configuration_entry={advanced_configuration_entry}
            advanced_configuration_entry_valid={advanced_configuration_entry_valid}
            advanced_configuration_entry_invalid_text={advanced_configuration_entry_invalid_text}
            updateadvanced_configuration_operation={updateadvanced_configuration_operation} advanced_configuration_operation={advanced_configuration_operation}
            advanced_configuration_operation_valid={advanced_configuration_operation_valid}
            advanced_configuration_operation_invalid_text={advanced_configuration_operation_invalid_text}
            updateadvanced_configuration_stanza={updateadvanced_configuration_stanza} advanced_configuration_stanza={advanced_configuration_stanza}
            advanced_configuration_stanza_valid={advanced_configuration_stanza_valid}
            advanced_configuration_stanza_invalid_text={advanced_configuration_stanza_invalid_text}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <AdvancedconfigurationEdit  loadGrid={advanced_configurationloadGrid} dataLoad={dataLoad} name={"advanced_configuration"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updateadvanced_configuration_entry={updateadvanced_configuration_entry} advanced_configuration_entry={advanced_configuration_entry}
            advanced_configuration_entry_valid={advanced_configuration_entry_valid}
            advanced_configuration_entry_invalid_text={advanced_configuration_entry_invalid_text}
            updateadvanced_configuration_operation={updateadvanced_configuration_operation} advanced_configuration_operation={advanced_configuration_operation}
            advanced_configuration_operation_valid={advanced_configuration_operation_valid}
            advanced_configuration_operation_invalid_text={advanced_configuration_operation_invalid_text}
            updateadvanced_configuration_stanza={updateadvanced_configuration_stanza} advanced_configuration_stanza={advanced_configuration_stanza}
            advanced_configuration_stanza_valid={advanced_configuration_stanza_valid}
            advanced_configuration_stanza_invalid_text={advanced_configuration_stanza_invalid_text}
                    />
                  </Suspense>
              </div>
            </div>
          </div>
        </div>
    );
};
export default AdvancedPage;
